import ControllerBase from '../../../../global/js/ControllerBase';


export default class ControllerFhwProfileHeader extends ControllerBase {


    private shareButton: HTMLButtonElement;
    private installerUrl;
    private installerName;

    constructor(element: HTMLElement) {
        super(element);
        this.init();
    }


    private init(): void {
        this.shareButton = this.$element?.querySelector("#share-button") as HTMLButtonElement;
        this.installerUrl = this.$element.getAttribute('data-installer-url');
        this.installerName = this.$element.getAttribute('data-installer-name');
        this.registerEvents();
    }

    private registerEvents() {
        this.shareButton?.addEventListener('click', () => this.shareHandler());
    }

    // Share URL
    private shareHandler() {
        const windowNavigator = window.navigator;
        const title = document.head?.querySelector('title')?.textContent || this.installerName;
        const text = document.head?.querySelector('meta[name="description"]')?.getAttribute('content') || "Wolf Experte";
        const shareData = {
            title,
            text,
            url: this.installerUrl
        };

        if (windowNavigator && windowNavigator.share) {
            windowNavigator
                .share(shareData)
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
        } else {
            alert('Successfully copied to clipboard!');
            windowNavigator.clipboard.writeText(shareData.url)
        }
    }

}


